import { doRequest } from './doRequest';

export const getServices = async () => {
  const response = await doRequest('/services', 'GET', null, true);
  return response;
};